import { CustomNode } from '../../../types';
import { triggerWorkflowIcon } from '../../../icons';

const DEFAULT_ICON = triggerWorkflowIcon;

export const triggerWorkflowConfig: CustomNode = {
  getNodeConfig() {
    return {
      icon: DEFAULT_ICON,
    };
  },
};
